import type { TOC } from '@ember/component/template-only';
import { Section } from 'tio-reimagined/components/layout';

export interface TuitionAssistanceLimitsSummaryContainerSignature {
  Element: HTMLElement;
  Args: {
    title?: string;
    titleClass?: string;
  };
  Blocks: {
    default: [];
  };
}

const TuitionAssistanceLimitsSummaryContainer: TOC<TuitionAssistanceLimitsSummaryContainerSignature> =
  <template>
    <Section ...attributes>
      <:header>
        <p class="{{@titleClass}}">{{@title}}</p>
      </:header>
      <:body>
        <dl class="w-full grid grid-cols-7 gap-2">
          {{yield}}
        </dl>
      </:body>
    </Section>
  </template>;

export default TuitionAssistanceLimitsSummaryContainer;
